// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { IProjectReleaseModel } from '../models/ProjectReleaseModel';
import UniversalSelect from './UniversalSelect';

interface ISelectProjectReleaseProps {
  releases: IProjectReleaseModel[];
  onChange: Function;
  defaultReleaseId: number;
  routes: string;
  renderContent: boolean;
  disablePortal?: boolean;
  size?: 'small' | 'medium';
}

interface ISelectValue {
  value?: number;
  label: string;
  startDate?: string;
  releasedate?: string;
}

const SelectProjectRelease: React.FC<ISelectProjectReleaseProps> = ({
  releases,
  onChange,
  defaultReleaseId,
  routes,
  renderContent,
  disablePortal = false,
  size = 'small',
}) => {
  const handleReleaseDetailsClick = (release: IProjectReleaseModel) => {
    const indexOfReturnUrl = window.location.href.indexOf('/', 8);
    const returnUrl = window.location.href.substring(indexOfReturnUrl);
    const routeString =
      routes.replace('#', `${release.releaseId}`) + '&returnUrl=' + encodeURIComponent(returnUrl);
    window.location.href = routeString;
  };

  return (
    <UniversalSelect
      fullWidth={true}
      data={releases}
      getOptionValue={(release) => release.releaseId}
      getOptionLabel={(release) => release.releaseVersion}
      getAdditionalFields={(release) => ({
        startDate: release.startDate,
        releaseDate: release.releaseDate,
      })}
      onChange={(value) => onChange(value)}
      onDetailsClick={handleReleaseDetailsClick}
      defaultValue={defaultReleaseId}
      loading={renderContent}
      disablePortal={disablePortal}
      size={size}
      allOptionLabel="All Tasks"
      allOptionValue={0}
    />
  );
};

export default SelectProjectRelease;
